// extracted by mini-css-extract-plugin
export default {"page":"nR-z","cartModal":"oR-z","checkout":"pR-z","placeholder":"qR-z","account":"rR-z"};